import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createPackageSameBarcode = createAction(ACTION.CREATE_PACKAGE_SAME_BARCODE.REQUEST, data => data);
export const clearState = createAction(ACTION.CLEAR_STATE);
